import Modal from '../Modal/Modal';
import CarMainData from '../../pages/Car/CarMainData';
import { textStyles } from '../../constants/textStyles';
import { colors } from '../../constants/colors';

const CarFixModal = ({ isOpen, car, missingFields, remainingCount, onFixed, onSkip }) => {
  if (!car) return null;

  const carTitle = `ID${car?.id} ${car?.mark || ''} ${car?.model || ''}`.trim();

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onSkip}
      shouldCloseOnOverlayClick={false}
      title="ÐÐ°Ð¿Ð¾Ð»Ð½Ð¸ÑÐµ Ð´Ð°Ð½Ð½ÑÐµ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ"
      contentStyle={{ maxHeight: '90vh', overflowY: 'auto' }}
    >
      <div style={{ display: 'grid', gap: 16 }}>
        <div
          style={{
            background: colors.rowYellowBG,
            border: `1px solid ${colors.orange}`,
            borderRadius: 8,
            padding: '12px 16px',
          }}
        >
          <p style={{ ...textStyles.fieldLabel, marginBottom: 6 }}>
            ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ {carTitle} Ð½ÐµÐ»ÑÐ·Ñ Ð´Ð¾Ð±Ð°Ð²Ð¸ÑÑ Ð² ÑÐ´ÐµÐ»ÐºÑ â Ð½Ðµ Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ñ Ð¾Ð±ÑÐ·Ð°ÑÐµÐ»ÑÐ½ÑÐµ Ð¿Ð¾Ð»Ñ:
          </p>
          <p style={{ ...textStyles.fieldLabel, color: colors.red, fontWeight: 700 }}>{missingFields?.join(', ')}</p>
          <p style={{ ...textStyles.inputPlaceholder, marginTop: 6 }}>
            ÐÐ°Ð¿Ð¾Ð»Ð½Ð¸ÑÐµ Ð¿Ð¾Ð»Ñ Ð½Ð¸Ð¶Ðµ Ð¸ Ð½Ð°Ð¶Ð¼Ð¸ÑÐµ Â«Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸ÑÂ» â Ð¿Ð¾ÑÐ»Ðµ ÑÑÐ¾Ð³Ð¾ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ Ð±ÑÐ´ÐµÑ Ð´Ð¾Ð±Ð°Ð²Ð»ÐµÐ½ Ð² ÑÐ´ÐµÐ»ÐºÑ.
          </p>
        </div>

        {remainingCount > 1 && (
          <p style={{ ...textStyles.inputPlaceholder }}>ÐÑÑÐ°Ð»Ð¾ÑÑ Ð¿ÑÐ¾Ð²ÐµÑÐ¸ÑÑ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»ÐµÐ¹: {remainingCount}</p>
        )}

        <CarMainData containerId={car?.id} onSaved={onFixed} />

        <p
          style={{ ...textStyles.buttonText, textDecoration: 'underline', cursor: 'pointer', textAlign: 'center' }}
          onClick={onSkip}
        >
          ÐÐµ Ð´Ð¾Ð±Ð°Ð²Ð»ÑÑÑ ÑÑÐ¾Ñ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ Ð² ÑÐ´ÐµÐ»ÐºÑ
        </p>
      </div>
    </Modal>
  );
};

export default CarFixModal;
